import React from 'react';

import SidebarPanel from 'ff/debrief/layouts/SidebarPanel';

import SidebarTabs, { SHARED } from './SidebarTabs';
import SharedTracklogList from './SharedTracklogList';
import { isFeatureEnabled } from 'ff/common/ffAppUtils';

const SharedSidebar = () => {
    return (
        <SidebarPanel>
            {isFeatureEnabled('new_share_debrief_feature') && (
                <SidebarTabs currentTab={SHARED} />
            )}
            <SharedTracklogList />
        </SidebarPanel>
    );
};

export default SharedSidebar;
